
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import './form-check-eligibility-optimum-bank-account.component.scss';

import * as $ from 'jquery';

export class FormCheckEligibilityOptimumBankAccount extends Base {

	// service
	checkEligibility: any;

	// elements
	form: HTMLFormElement;
	submitButton: Element[];
	checkboxSameNationality: any;
	dropdownNationality: Element;
	dropdownResidence: Element;
	inputDateOfBirth: any;
	radioClient: Element[];
	closeButton: Element;

	// containers
	containerNationality: Element;
	containerUsingProducts: Element;
	containerFields: Element;
	containerButtons: Element;
	containerNote: Element;
	containerThankyou: Element;
	containerInvalidAge: Element;
	containerInvalidLocation: Element;
	containerValid: Element;
	containerValidExisting: Element;
	containerValidOffshore: Element;
	containerValidExpat: Element;
	containerValidOther: Element;
	containerParentButtons: any;
	containerModal: any;
	containerLoader: any;

	// values
	valuesJson: any;
	valueLeadType: string;
	valueClient: boolean = false;
	valueFormValid: boolean = false;
	valueNationality: string = "";
	valueResidence: string = "";
	valueModalId: string = "";
	valueDateOfBirth: string = "";

	// storage
	eligibilityStorage: any;


	constructor(element: Element, analyticsService: AnalyticsService) {
		super(element);
	}

	init() {	

		this.checkEligibility = new CheckEligibility();
		this.form = this.element.querySelector('form') as HTMLFormElement;

		this.radioClient = Array.from(this.element.querySelectorAll('.js-using-international-products__radio'));
		this.checkboxSameNationality = this.element.querySelector('.js-same-as-nationality');
		this.dropdownNationality = this.element.querySelector('.js-nationality');
		this.dropdownResidence = this.element.querySelector('.js-residence');
		this.inputDateOfBirth = this.element.querySelector('.js-date-of-birth');
		this.submitButton = Array.from(this.element.querySelectorAll('.js-check-eligibility-submit__button'));

		this.containerFields = this.element.querySelector('.form__fields--container');
		this.containerNote = this.element.querySelector('.apply-now__note');
		this.containerButtons = this.element.querySelector('.apply-now__buttons');
		this.containerNationality = this.element.querySelector('div.form-check-eligibility-optimum-bank-account__group[data-group-name=nationality]');	
		this.containerUsingProducts = this.element.querySelector('div.form-check-eligibility-optimum-bank-account__group[data-group-name=using_international_products]');	
		this.containerThankyou = this.element.querySelector('.form__thankyou--container');	
		this.containerInvalidAge = this.element.querySelector('.js-invalid-age-container');
		this.containerInvalidLocation = this.element.querySelector('.js-invalid-location-container');
		this.containerValid = this.element.querySelector('.js-valid-container');	
		this.containerValidExisting = this.element.querySelector('.js-valid-existing-container');
		this.containerValidOffshore = this.element.querySelector('.js-valid-allowedoffshore-container');	
		this.containerValidExpat = this.element.querySelector('.js-valid-allowedexpat-container');	
		this.containerValidOther = this.element.querySelector('.js-valid-allowedother-container');	
		this.containerLoader = this.element.querySelector('.form__loader--container');

		this.containerModal = this.element.closest('.form-container');
		this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');	

		this.valuesJson = {
			operation: "open",
			category: "individual",
			leadType: "",
			leadCTA: "CHECK ELIGIBILITY",
			leadStatus: "Open",
			eligibilityFormId: "",
			eligibilityCTA: "",
			clientWIN: "N",
			sbgPrivateClient: "N",
			yachtCrew: "N",
			referralCode: "",
			coN: "",
			coR: "",
			doB: "",
			countryEligibilty: "",
			productName: "",
			pageUrl: ""
		}

	}

	bindEvents() {

		// radio buttons - using products
		this.radioClient.map((item) => item.addEventListener('click', (event) => {	

			const element: any = event.target;
			this.containerNationality.classList.add('form-check-eligibility-optimum-bank-account--hidden');
			this.containerNote.classList.add('form-check-eligibility-optimum-bank-account--hidden');
			this.containerButtons.classList.add('form-check-eligibility-optimum-bank-account--hidden');	
			if (element.value == "no") {
				this.valuesJson.clientWIN = 'N';
				this.valueClient = false;
				this.valueFormValid = false;
				this.containerNationality.classList.remove('form-check-eligibility-optimum-bank-account--hidden');
			} else {
				this.valuesJson.clientWIN = 'Y';
				this.valueClient = true;
				this.valueFormValid = true;
			}	
			this.containerNote.classList.remove('form-check-eligibility-optimum-bank-account--hidden');
			this.containerButtons.classList.remove('form-check-eligibility-optimum-bank-account--hidden');	

		}));

		// dropdown nationality
		this.dropdownNationality.addEventListener('change', (event)=>{
			let element: any = event.target;
			this.valueNationality = element.value;
			this.valuesJson.coN = element.value;
		});

		// dropdown residence
		this.dropdownResidence.addEventListener('change', (event)=>{
			let element: any = event.target;
			if(!this.checkboxSameNationality.checked){
				this.valueResidence = element.value;
			}else{
				$(this.checkboxSameNationality)[0].checked = false;
			}
			this.valuesJson.coR = element.value;
		});

		// checkbox same nationality
		this.checkboxSameNationality.addEventListener('click', (event) => {
			let element: any = event.target;
			let formField: any = this.dropdownResidence;
			let formGroup: any = this.dropdownResidence.closest('.form__group');
			if(element.checked){
				this.valueResidence = this.valueNationality;
				formField.classList.remove('form__input--required');
				formGroup.classList.remove('form__group--error');
				this.dropdownResidence.selectedIndex = 0;
			}else{
				formField.classList.add('form__input--required');
				formGroup.classList.add('form__group--error');
			}
			this.valuesJson.coR = this.valueNationality;
		});

		// date of birth keypress check
		this.inputDateOfBirth.addEventListener('keyup', (event: any) => {
			let component = event.target;
			if(component.value){
				let value = component.value;
				this.valueDateOfBirth = value;
				let result = this.checkEligibility.isBeforeToday(value, component);
				this.valuesJson.doB = value;
			}
		});

		// date of birth onchange check
		this.inputDateOfBirth.addEventListener('change', (event: any) => {
			let component = event.target;
			if(component.value){
				let value = component.value;				
				this.valueDateOfBirth = value;			;
				let result = this.checkEligibility.isBeforeToday(value, component);
				this.valuesJson.doB = value;
			}
		});

		// submit button
		this.submitButton.map((item) => item.addEventListener('click', (event) => {
						
			let formModal = this.element.closest('.js-apply-now-modal');
			this.valueModalId = formModal.getAttribute('id');

			if(this.valueFormValid){
				this.valuesJson.leadType = "IPB Sales";
				this.applyFilters('callmeback', this.valueModalId);

			}else{
				const formFields: any = this.form.querySelectorAll('input, select');
				let validation: any = this.validationService.validate(formFields);
				let validDateOfBirth = this.checkEligibility.isBeforeToday(this.valueDateOfBirth, this.inputDateOfBirth);
				if (validation.valid && validDateOfBirth) {
					
					let equalAfricanCountries = this.checkEligibility.equalAfricanCountries(this.valueNationality, this.valueResidence);
					let equalOffshore = this.checkEligibility.equalOffshore(this.valueNationality, this.valueResidence);
					let allowedExpat = this.checkEligibility.allowCountryExPats(this.valueNationality, this.valueResidence);
					let allowedOther = this.checkEligibility.allowCountryOther(this.valueNationality, this.valueResidence);					
					
					if(this.checkEligibility.validateDOB(this.inputDateOfBirth.value)){
						
						// equal valid african countries 
						if(equalAfricanCountries == true){					
							this.valuesJson.leadType = "LMM";
							this.valuesJson.countryEligibilty = "AllowedCountryAfrica";
							this.valuesJson.eligibilityCTA = "Apply Now";
							this.applyFilters('apply', this.valueModalId);

						}else{
							
							// equal valid offshore countries
							if(equalOffshore == true){			
								this.valuesJson.leadType = "LMM";
								this.valuesJson.countryEligibilty = "AllowedCountryOffshore";
								this.valuesJson.eligibilityCTA = "Apply Now";
								this.applyFilters('apply', this.valueModalId);
							
							}else{

								// invalid nationality but valid expat
								if(allowedExpat == true){			
									this.valuesJson.leadType = "LMM";
									this.valuesJson.countryEligibilty = "AllowedCountryExpat";
									this.valuesJson.eligibilityCTA = "Apply Now";
									this.applyFilters('apply', this.valueModalId);

								}else{

									if(allowedOther == true){
			
										this.valuesJson.leadType = "LMM";
										this.valuesJson.countryEligibilty = "AllowedCountryOther";
										this.valuesJson.eligibilityCTA = "Apply Now";
										this.applyFilters('apply', this.valueModalId);

									}else{

										// failed
										this.containerInvalidLocation.classList.add('active');	
										this.checkEligibility.changeButtons('contactus', this.valueModalId);

									}

								}
							}
						}
					}else{
						this.containerInvalidAge.classList.add('active');
						this.checkEligibility.changeButtons('contactus', this.valueModalId);
					}

					this.containerThankyou.classList.add('active');
					this.containerFields.classList.add('hidden');
				}
			}
		}));

		// close button - reset form
		this.closeButton.addEventListener('click', (event) => {
			
			this.containerValid.classList.remove('active');
			this.containerValidExisting.classList.remove('active');
			this.containerInvalidAge.classList.remove('active');
			this.containerInvalidLocation.classList.remove('active');
			this.containerValidOffshore.classList.remove('active');
			this.containerValidOffshore.classList.remove('active');
			this.containerValidExpat.classList.remove('active');
			this.containerValidExpat.classList.remove('active');
			this.containerValidOther.classList.remove('active');
			this.containerValidOther.classList.remove('active');

			this.containerValid.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerValidExisting.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerInvalidAge.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerInvalidLocation.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerValidOffshore.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerValidOffshore.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerValidExpat.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerValidExpat.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerValidOther.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
			this.containerValidOther.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');

			let selectResidence = this.element.querySelector('select.js-residence');
			selectResidence.classList.add('form__input--required');

			this.analyticsService.dtmFormAbandon();
			
		});

		$(document).on('click', '.js-apply-now-modal-open', (event) => {

			let element = event.target;
			let type = $(element).attr('data-productname');
			let modal = $(element).attr('data-modal');
			let data = $(element).attr('data-text');
			let dataArray = data.split(" | ");
			let dataNewFormName = "checkeligibility | wealth bank accounts | " + type;
			this.form.setAttribute('data-frmcontainer', dataNewFormName);
			this.valuesJson.pageUrl = window.location.href;
			if(type){
				this.valuesJson.productName = type;
			}
			if(modal){
				this.valuesJson.eligibilityFormId = modal;
			}

			this.formstart();
			
		});

	}

	applyFilters(type, modalId){		

		let containerLoader = this.containerLoader;
		let containerValidExisting = this.containerValidExisting;
		let containerThankyou = this.containerThankyou;
		let containerFields = this.containerFields;
		let containerValid = this.containerValid;
		let containerValidOffshore = this.containerValidOffshore;
		let containerValidExpat = this.containerValidExpat;
		let containerValidOther = this.containerValidOther;
		let checkEligibility = this.checkEligibility;

		containerFields.classList.add('hidden');
		containerLoader.classList.add('active');
		
		// variables
		let response = 'invalid';

		// fields
		let operation: any = this.valuesJson.operation;	
		let category: any = this.valuesJson.category;		
		let leadType: any = this.valuesJson.leadType;	
		let leadCTA: any = this.valuesJson.leadCTA;
		let leadStatus: any = this.valuesJson.leadStatus;
		let eligibilityCTA: any = this.valuesJson.eligibilityCTA;
		let eligibilityFormId: any = this.valuesJson.eligibilityFormId;
		let clientWIN: any = this.valuesJson.clientWIN;
		let sbgPrivateClient: any = this.valuesJson.sbgPrivateClient;
		let yachtCrew: any = this.valuesJson.yachtCrew;
		let referralCode: any = this.valuesJson.referralCode;
		let coN: any = this.valuesJson.coN;
		let coR: any = this.valuesJson.coR;
		let doB: any = this.valuesJson.doB;
		let countryEligibilty: any = this.valuesJson.countryEligibilty;
		let productName: any = this.valuesJson.productName;
		let pageUrl: any = this.valuesJson.pageUrl;

		// build string
		let postData = '';
		if (operation) {
			postData += 'operation=' + operation + '&';
		}
		if (category) {
			postData += 'category=' + category + '&';
		}
		if (leadType) {
			postData += 'leadType=' + leadType + '&';
		}
		if (leadCTA) {
			postData += 'leadCTA=' + leadCTA + '&';
		}
		if (leadStatus) {
			postData += 'leadStatus=' + leadStatus + '&';
		}
		if (eligibilityFormId) {
			postData += 'eligibilityFormId=' + eligibilityFormId + '&';
		}
		if (eligibilityCTA) {
			postData += 'eligibilityCTA=' + eligibilityCTA + '&';
		}
		if (clientWIN) {
			postData += 'clientWIN=' + clientWIN + '&';
		}
		if (sbgPrivateClient) {
			postData += 'sbgPrivateClient=' + sbgPrivateClient + '&';
		}
		if (yachtCrew) {
			postData += 'yachtCrew=' + yachtCrew + '&';
		}
		if (referralCode) {
			postData += 'referralCode=' + referralCode + '&';
		}
		if (coN) {
			postData += 'coN=' + coN + '&';
		}
		if (coR) {
			postData += 'coR=' + coR + '&';
		}
		if (doB) {
			let date = new Date(doB);
			var DD = (date.getDate() <= 9 ? '0': '') + date.getDate();
			var MM = (date.getMonth() < 9 ? '0': '') + (date.getMonth()+1);
			var YYYY = date.getFullYear();
			let value = DD + '/' + MM +'/' + YYYY;
			postData += 'doB=' + value + '&';
		}
		if (countryEligibilty) {
			postData += 'countryEligibilty=' + countryEligibilty + '&';
		}
		if (productName) {
			postData += 'productName=' + productName + '&';
		}
		if (pageUrl) {
			postData += 'pageUrl=' + pageUrl + '&';
		}

		// config
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitWINLead.jsp";				
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, postData, config).then(function (response) {

			if (response.data === 'invalid') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				containerLoader.classList.remove('active');
				containerFields.classList.remove('hidden');
				checkEligibility.changeButtons(type, modalId, '');
			} else {
				response = response.data;
				containerLoader.classList.remove('active');
				if(type === 'callmeback'){
					containerValidExisting.classList.add('active');
					containerThankyou.classList.add('active');
					containerFields.classList.add('hidden');
				}else if(type === 'apply'){

					if(countryEligibilty === 'AllowedCountryOffshore'){
						containerValidOffshore.classList.add('active');	
					}else if(countryEligibilty === 'AllowedCountryExpat'){
						containerValidExpat.classList.add('active');	
					}else if(countryEligibilty === 'AllowedCountryOther'){
						containerValidOther.classList.add('active');	
					}else{
						containerValid.classList.add('active');	
					}
				}
				checkEligibility.changeButtons(type, modalId, response);
			}
			analyticsService.dtmFormComplete('complete', 'Submitted');

		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);

		});

	}

	resetForm() {
		if (this.form) {
			this.form.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}
	}

	formstart() {

		let dataNewFormName = "checkeligibility | wealth bank accounts | " + this.valuesJson.productName;
		this.analyticsService.dtmFormNameUpdate(dataNewFormName);
		this.analyticsService.dtmAllowFormRefresh();

	}

}



// WEBPACK FOOTER //
// ./components/form-check-eligibility-optimum-bank-account/form-check-eligibility-optimum-bank-account.component.ts